import { useMemo } from "react";
import Markdown from "react-markdown";
import { ReactMarkdownOptions } from "react-markdown/lib/react-markdown";
import rehypeHighlight from "rehype-highlight";
import remarkGfm from "remark-gfm";
import { cn } from "utils/cn";

export function BotMarkdown({ children }: { children: string }) {
  const props = useMemo<Omit<ReactMarkdownOptions, "children">>(
    () => ({
      remarkPlugins: [remarkGfm],
      rehypePlugins: [rehypeHighlight],
      components: {
        a: (attrs) => (
          <StyledAnchor {...attrs} target="_blank" rel="noreferrer noopener" />
        ),
        table: (attrs) => <StyledTable {...attrs} />,
      },
    }),
    []
  );

  return <Markdown {...props}>{children}</Markdown>;
}

const StyledAnchor: React.FunctionComponent<
  React.ComponentPropsWithoutRef<"a">
> = (props) => (
  <a
    {...props}
    className={cn(
      "rounded-sm text-inherit underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zi-primary focus-visible:ring-offset-2 focus-visible:ring-offset-zi-lightPrimary",
      props.className
    )}
  />
);

const StyledTable: React.FunctionComponent<
  React.ComponentPropsWithoutRef<"table">
> = (props) => (
  <table
    {...props}
    className={cn(
      "w-full border-separate border-spacing-0 [&_thead]:border-b [&_thead]:border-zi-lightPrimary [&_tr]:border-b [&_tr]:border-zi-lightPrimary",
      "[&_th:first-of-type]:rounded-tl-md [&_th:last-of-type]:rounded-tr-md [&_th]:border-0 [&_th]:border-b [&_th]:border-l [&_th]:border-t [&_th]:border-solid [&_th]:border-zi-mediumGray [&_th]:bg-zi-primary/20 [&_th]:px-3 [&_th]:py-1 [&_th]:text-left [&_th]:font-semibold [&_th]:last-of-type:border-r",
      "[&_td]:border-0 [&_td]:border-b [&_td]:border-l [&_td]:border-solid [&_td]:border-zi-mediumGray [&_td]:px-3 [&_td]:py-1 [&_td]:text-left [&_td]:last-of-type:border-r",
      "[&_tbody>tr:last-of-type>td:first-of-type]:rounded-bl-md [&_tbody>tr:last-of-type>td:last-of-type]:rounded-br-md",
      props.className
    )}
  />
);
